import type { TravelerInformation as ApiTravelerInformation } from '@/shared/types/api.types'

export const getEmptyTravelerObject = (): ApiTravelerInformation => ({
  firstName: '',
  lastName: '',
  dateOfBirth: '',
  relationCode: '',
  relationName: '',
  nationalityCode: '',
  nationalityName: '',
  passportNo: '',
  winSports: 0,
})
